@if(hasImage()){
<div class="slideshow mb-1">
  <img class="img" [src]="img() + '?w=1920'" [alt]="alt()" />
  <div class="gradient"></div>
</div>
<div class="title container-md">
  <h1>{{ title() }}</h1>
</div>
}
